import { render, staticRenderFns } from "./priceListTables.vue?vue&type=template&id=5e2e859c&"
import script from "./priceListTables.vue?vue&type=script&lang=ts&"
export * from "./priceListTables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports